function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgSgd = function SvgSgd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("circle", {
    style: {
      fill: "#F0F0F0"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M0,256.001C0,114.616,114.616,0,256,0s256,114.616,256,256.001"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M155.826,133.564c0-37.298,26.213-68.456,61.217-76.101c-5.38-1.174-10.961-1.811-16.696-1.811 c-43.031,0-77.913,34.882-77.913,77.913s34.882,77.913,77.913,77.913c5.733,0,11.315-0.637,16.696-1.812 C182.039,202.021,155.826,170.863,155.826,133.564z"
  }), React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "256,61.217 261.526,78.222 279.407,78.222 264.94,88.733 270.466,105.738 256,95.229  241.534,105.738 247.06,88.733 232.594,78.222 250.474,78.222  "
  }), React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "212.625,94.608 218.15,111.614 236.031,111.614 221.565,122.124 227.091,139.129  212.625,128.62 198.157,139.129 203.684,122.124 189.217,111.614 207.098,111.614  "
  }), React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "299.376,94.608 304.903,111.614 322.783,111.614 308.316,122.124 313.843,139.129  299.376,128.62 284.91,139.129 290.436,122.124 275.97,111.614 293.85,111.614  "
  }), React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "282.681,144.695 288.207,161.701 306.087,161.701 291.621,172.211 297.147,189.216  282.681,178.707 268.215,189.216 273.741,172.211 259.275,161.701 277.154,161.701  "
  }), React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "229.32,144.695 234.845,161.701 252.727,161.701 238.26,172.211 243.787,189.216  229.32,178.707 214.853,189.216 220.379,172.211 205.913,161.701 223.794,161.701  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSgd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SGD.3d05a02d.svg";
export { ForwardRef as ReactComponent };